export default __webpack_public_path__ + "static/media/coins-select.018a6ebb.jpg";